import { Clazzes } from './pages';

export default {
  key: 'classes',
  path: '/classes',
  exact: true,
  component: Clazzes,
};
